<template>
  <v-container fluid>
    <v-row  dense>
      <v-col cols="12">
        <DataTableMain :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"/>
      </v-col>
      <v-col cols="12">
        <ViewDetails :object="object" type="SolicitudAlta" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import { UserSession } from '@/store/modules/config'
import DataTableMain from '@/components/tables/DataTableMain'
import ViewDetails from '@/components/ViewDetails'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'seguimiento.solicitudes.create' }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Fecha', value: 'ObjetDateDinamic', class: 'black--text', showItemColum: 'created_at' },
          // { text: 'Folio Fiscal', value: 'factura.caracteristicas.', class: 'black--text' },
          { text: 'Folio Fiscal', value: 'factura.FolioAb', class: 'black--text' },
          { text: '# Inventarios', value: 'NumeroInventarios', class: 'black--text' },
          { text: 'Departamento Asignado', value: 'departamento_asignado.nombre', class: 'black--text' },
          { text: 'Empleado Asignado', value: 'empleado_asignado.NombreCompleto', class: 'black--text' },
          { text: 'Estatus', value: 'Status', class: 'black--text', align: 'center' },
          { text: '', value: 'Actions', align: 'right' }
        ],
        loading: false,
        filter: true
      },
      body: {
        data: [],
        actions: [
          { title: 'Reporte de Alta', icon: 'mdi-file-pdf-box', color: 'amber darken-2', action: 'DownloadPdfData', code: 'libre', hidden: '' }
          // { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'updateData', code: 'inventariable.solicitudes_transferencia.entry' },
          // { title: 'Desc de Transferencia', icon: 'mdi-file-pdf-box', color: 'amber darken-2', action: 'DownloadPdfData', code: 'solicitudes.show.rpt' }
        ]
      },
      footer: {
        paging: true
      }
    },
    user: {},
    showAlert: false
  }),
  components: {
    DataTableMain,
    ViewDetails
  },
  mounted () {
    this.user = UserSession()
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjects', 'GETExportPdftSerice', 'GETExportPdftSerice']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SET_SERVICES']),
    SuccessTableAction (item) { this[item.action](item) },
    filterData (item) {
    },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.GETObjects({ url: router })
      } else { this.getUrlServices() }
    },
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('seguimiento.solicitudes-alta.show')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        form: 'process',
        with: '80%',
        title: 'Facturas e Inventarios de Alta ',
        body: {
          objectMain: {},
          paramsDialog: {
            url: this.get_urls['seguimiento.solicitudes.execute'],
            urloption: this.get_urls['seguimiento.solicitudes.options'],
            message: 'Registro Agregado Correctamente',
            returnObject: true
          }
        }
      })
    },
    toAssign (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'asign',
        form: 'process',
        with: '70%',
        title: 'Asignacion de Departamento',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.solicitudes.execute'],
            urloption: this.get_urls['seguimiento.solicitudes.options'],
            message: 'Registro Agregado Correctamente',
            returnObject: true
          }
        }
      })
    },
    toFinish (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'finish',
        form: 'process',
        with: '70%',
        title: 'Finalizar Alta de Inventario',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.solicitudes.execute'],
            urloption: this.get_urls['seguimiento.solicitudes.options'],
            message: 'Registro Agregado Correctamente',
            returnObject: true
          },
          method: 'form-data'
        }
      })
    },
    DownloadPdfData ({ item }) {
      this.GETExportPdftSerice({ url: this.get_urls['seguimiento.altas.rpt'], replace: '{id}', params: item.id })
    }
  },

  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects', 'get_sendDataView']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) { this.refreshData({}) },
    get_objects (vals) {
      if (vals) {
        this.table.body.data = vals
      }
      this.table.header.loading = false
    },
    get_sendDataView ({ name, model }) {
      this.refreshData({})
    }
  }
}
</script>

<style >

</style>
